import {TYPES} from 'components/DjangoMessages';
import Notification from 'components/Notification';
import {FC} from 'react';

import {MailpointsInitialData} from '../types';

interface Props {
    message: MailpointsInitialData['data']['stripeMessage'];
}

const StripeMessage: FC<Props> = ({message}) => {
    if (!message) {
        return null;
    }

    return (
        <Notification type={TYPES[message?.levelTag]}>
            {message?.message}
        </Notification>
    );
};

export default StripeMessage;
